module.exports = __webpack_public_path__ + "img/zhongyu.c813fe4e.png";